import { gql } from 'apollo-boost'

const CREATE_SCRAPING_TAG = gql`
  mutation createScrapingTag($name: String!) {
    createScrapingTag(name: $name) {
      id
      name
    }
  }
`

export default CREATE_SCRAPING_TAG
